import { render, staticRenderFns } from "./Interessados.vue?vue&type=template&id=e0d4a69a"
import script from "./Interessados.vue?vue&type=script&lang=js"
export * from "./Interessados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports